export const whitePages = ['/cadastro'];
